type Mods = Record<string, string | boolean | undefined | null>;

export function classNames(cls: (string | undefined)[], mods: Mods = {}): string {
  const modCls = Object.entries(mods)
    .filter(([, value]) => Boolean(value))
    .map(([key]) => key);
  return [...cls.filter(Boolean), ...modCls].join(" ");
}
